import dsBridge from 'dsbridge';
// 需要调用 关闭 webview 的 jsbridge 的页面
const closePaths = [
  '/',
  '/feedbacks/new',
  '/feedbacks/success',
  '/support-manager',
];
// 需要隐藏原生导航头的 页面
const hiddenNavBarPaths = [
  '/',
  '/feedbacks',
  '/topics',
  '/support-manager'
]

document.addEventListener('turbolinks:load', () => {
  const { pathname } = window.location;
  if(hiddenNavBarPaths.some(path => pathname.startsWith(path))) {
    // 隐藏 navbar
    dsBridge.call('lbConfig', {
      name: 'navigationBar',
      hidden: true
    }, resp => {});
  }
  
  // 解除上一个页面的绑定事件
  $('body').off('click')

  // 清除搜索框
  $('body').on('click', '.search-box .clear', (e) => {
    $('.search-box .search-input').val('');
  });

  // 返回按钮事件
  $('body').on('click', 'header .back-btn', (e) => {
    if (closePaths.indexOf(pathname) !== -1 || window.history.length === 1) {
      dsBridge.call('lbCloseWebView');
    } else {
      // 如果返回地址不变，调用 closewebview 方法
      const currentUrl = location.href
      window.history.back();
      setTimeout(() => {
        if (currentUrl === location.href) {
          // 如果使用同步方法，ios 调用一次以后，第二次调用该 bridge 无法生效
          dsBridge.call('lbCloseWebView');
        }
      }, 300)
    }
  });

  // 分享按钮事件
  $('body').on('click', 'header .share-btn', () => {
    const title = document.querySelector('.share-btn').getAttribute('data-title')
    const hasQuery = location.href.indexOf('?') !== -1
    const url = `${location.href}${hasQuery ? '&' : '?'}hide-header=true`
    const data = {
      url,
      title,
      descr: '连接未来，投资全球'
    };
    dsBridge.call('lbShowSharedUrl', data, resp => {})
  });

  // 关闭 webview
  $('body').on('click', '.btn-close-webview', (e) => {
    dsBridge.call('lbCloseWebView');
  });

  // 调用原生七鱼在线客服
  $('body').on('click', '.customer-services', (e) => {
    e.preventDefault();
    dsBridge.call('lbGetNativePage', { page: 'customerService' });
  });
});
